import { createRoot, StrictMode } from "@modica-library/react19";
import "./themes"; // active brand theme design-system tokens (EziTxt) — themes @modica-library components
import "./theme.css"; // app-level tokens/overrides layered on top
import { App } from "./App";

const el = document.getElementById("root");
if (!el) throw new Error("root element not found");
createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>
);
